export default {
  name: 'KTimeline',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    thin: {
      type: Boolean,
      default: false,
    },
    dotPlacement: {
      type: String,
      default: null,
    },
    joinLine: {
      type: Boolean,
      default: false,
    },
    // 最后节点的小尾巴
    tailed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
  render() {
    const css = {
      'km-timeline': true,
      'km-timeline--thin': this.thin,
      'km-timeline--tailed': this.tailed,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        {this.$slots.default}
      </div>
    )
  }
  ,
}
